// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CreateTicketResponseApiModel from "../api-model/CreateTicketResponseApiModel.bs.js";

function apiModelToState(res) {
  return {
          ticket_id: res.ticket_id,
          message: res.message
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(CreateTicketResponseApiModel.t_decode(json), "CreateTicketResponseEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
